import {FeatureItem} from "../../FeatureItemCard/types"

export function getMainDisclaimer(orgName: string, bankName: string): {id: string; description: string[]} {
	return {
		id: "¹",
		description: [
			`${orgName} is a financial technology company and is not a bank. Banking services are provided by ${bankName}, Member FDIC. The ${orgName} Visa Debit Card is issued by ${bankName} pursuant to a license from Visa U.S.A. Inc. and may be used anywhere Visa cards are accepted.`,
			`Deposits may qualify for up to $3,000,000 in FDIC insurance coverage when placed at program banks in the ${bankName} sweep program. Accounts are eligible for pass-through deposit insurance only to the extent pass-through insurance is permitted by the rules and regulations of the FDIC, and if the requirements for pass-through insurance are satisfied. There may be a risk that pass-through deposit insurance is not available because conditions have not been satisfied. In such cases, funds may not be fully insured in the event the insured depository institution where the funds have been deposited were to fail.`,
		],
	}
}

export const featuresItems: FeatureItem[] = [
	{
		icon: "analytic-percentage--business-products",
		title: "Up to 2.5% Annual Percentage Yield",
		description: "Deposit account with up to 2.5% APY and up to $3 million in FDIC insurance coverage",
		note: {
			id: "²",
			description:
				"Annual Percentage Yield (APY) is variable and is subject to change after account opening. Rate is compounded monthly and credited monthly.",
		},
	},
	{
		icon: "money-transfer--business-products",
		title: "Payments",
		description: "ACH, same-day ACH, and checks. Free, instant, 24/7 book transfers.",
	},
	{
		icon: "credit-card",
		title: "Cards",
		description: "Physical and virtual debit cards for multiple user types.",
	},
	{
		icon: "Atm-Socket-Money-Withdraw",
		title: "ATM",
		description: "ATM cash deposits and withdrawals at over a thousand fee-free* locations nationwide.",
		note: {
			id: "³",
			description:
				"No account or domestic transaction fees. Some foreign transaction fees may apply in limited circumstances.",
		},
	},
	{
		icon: "Smartphone-Action-Money-Fund",
		title: "Mobile Check Deposit",
		description: "Offer your customers an easy way to deposit their check via their mobile phones.",
	},
	{
		icon: "user-multiple-new",
		title: "Role-Based Access",
		description: "Enable multiple authorized user types on your account for role-based access.",
	},
	{
		icon: "Power-Cable--SIcons_Mix",
		title: "Integrations",
		description: "Integration to Plaid and Intuit to enable seamless business connectivity.",
	},
]

export const mockFeaturesItemsWithNotes: FeatureItem[] = [
	{
		icon: "analytic-percentage--business-products",
		title: "1% APY",
		description: "1% APY* Accounts, FDIC Insurance up to $250,000 available for funds on deposit.",
		note: {
			id: "1",
			description:
				"Accounts are eligible for pass-through deposit insurance only to the extent pass-through insurance is permitted by the rules and regulations of the FDIC, and if the requirements for pass-through insurance are satisfied. There may be a risk that pass-through deposit insurance is not available because conditions have not been satisfied. In such cases, funds may not be fully insured in the event the insured depository institution where the funds have been deposited were to fail.",
		},
	},
	{
		icon: "money-transfer--business-products",
		title: "Payments",
		description: "ACH, same-day ACH, and checks. Free, instant, 24/7 book transfers.",
	},
	{
		icon: "credit-card",
		title: "Cards",
		description: "Physical and virtual debit cards for multiple user types.",
	},
	{
		icon: "Atm-Socket-Money-Withdraw",
		title: "ATM",
		description: "ATM cash deposits and withdrawals at over a thousand fee-free locations nationwide.",
		note: {
			id: "2",
			description:
				"You can find Allpoint ATMs throughout the United States and around the globe at over 55,000 locations. https://www.allpointnetwork.com/locator",
		},
	},
	{
		icon: "Smartphone-Action-Money-Fund",
		title: "Mobile Check Deposit",
		description: "Offer your customers an easy way to deposit their check via their mobile phones.",
	},
	{
		icon: "user-multiple-new",
		title: "Role-based access",
		description: "Enable multiple authorized user types on your account for role-based access.",
	},
]
